import { createAction, props } from '@ngrx/store';
import { Card, Company, Contact, Customer, Funnel, LossReason, Pager, Product, SearchParams, Stage, User } from 'lib-trend-core';
import { ParamsState } from './app.state';

// app state
export const clearFullState = createAction('[Clear] Full state', props<{ clear: boolean }>());

export const getLoadInit = createAction('[Init] Load initial', props<{ idUser: string, idCompany: string }>());
export const setLoadInit = createAction('[Init] Set initial', props<{ user: User, company: Company }>());

export const getFunnels = createAction('[Funnel] Get Funnels', props<{ search?: string, params?: Partial<SearchParams> }>());
export const getFunnel = createAction('[Funnel] Get Funnel', props<{ idFunnel: string }>());
export const getStages = createAction('[Stage] Get Stages', props<{ idFunnel: string }>());
export const getStage = createAction('[Stage] Get Stage', props<{ idStage: string }>());
export const getCards = createAction('[Card] Get Cards', props<{ page: number, perPage: number, search?: string, params?: Partial<SearchParams> }>());
export const getCard = createAction('[Card] Get Card', props<{ idCard: string }>());
export const getProducts = createAction('[Product] Get Products', props<{ idCompany: string }>());
export const getCustomers = createAction('[Product] Get Products', props<{ idCompany: string }>());
export const getLossReasons = createAction('[Product] Get Products', props<{ idCompany: string }>());
export const getContacts = createAction('[Product] Get Products', props<{ page: number, perPage: number, search?: string, params?: Partial<SearchParams> }>());

export const setFunnels = createAction('[Funnel] Set Funnels Success', props<{ funnels: Array<Funnel> }>());
export const setFunnel = createAction('[Funnel] Set Funnel', props<{ funnel: Funnel }>());
export const setStages = createAction('[Stage] Set Stages Success', props<{ stages: Array<Stage> }>());
export const setStage = createAction('[Stage] Set Stage Success', props<{ stage: Stage }>());
export const setCards = createAction('[Card] Set Cards Success', props<{ cards: Pager<Card> }>());
export const setCard = createAction('[Card] Set Card', props<{ card: Card }>());
export const setProducts = createAction('[Product] Set Products', props<{ products: Array<Product> }>());
export const setCustomers = createAction('[Customer] Set Customers', props<{ customers: Array<Customer> }>());
export const setLossReasons = createAction('[LossReason] Set Loss Reasons', props<{ lossReasons: Array<LossReason> }>());
export const setContacts = createAction('[Contact] Set Contacts', props<{ contacts: Pager<Contact> }>());

export const setQueryParams = createAction('[Card queryParams] Set queryParams of Card', props<{ queryParams: ParamsState }>());

export const setFailure = createAction('[Failure] Error', props<{ error: string }>());
